import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import {AuthService} from "../_services/auth_service";
import {HttpResponse} from "@angular/common/http";
import { TranslateService } from '@ngx-translate/core';
import {LanguageService} from "../_services/language_service";
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
    model: any[] = [];
    role: string | null = null;
    medicoId: string|null = "";

    private langSubscription!: Subscription;

    constructor(
        private authService: AuthService,
        private translate: TranslateService,
        private languageService: LanguageService
    ) {
    }

    ngOnInit() {

        this.authService.getUserData().subscribe({
            next: (response: HttpResponse<any>) => {
                this.role = response.body.ruolo;
                this.medicoId = response.body.id;

                this.setupMenu();

                this.langSubscription = this.languageService.languageChanged$.subscribe(lang => {
                    //console.log('Lingua cambiata:', lang);
                    this.setupMenu();
                });

            }
        });


    }

    setupMenu() {
        const menuLabels = [
            'Area pazienti',
            'Cartella anamnestica',
            'Consulti acquistati',
            'Comandi rapidi',
            'Richiedi consulto',
            'Cambia password',
            'Convenzioni',
            'Documenti fiscali'
        ];  // Le etichette da tradurre
        const translatedLabels: any = {};

        menuLabels.forEach(label => {
            this.translate.get(label).subscribe(translated => {
                translatedLabels[label] = translated;
            });
        });

        this.updateMenu(translatedLabels);  // Quando tutte le etichette sono tradotte

    }

    updateMenu(translatedLabels: any) {
        this.model = [
            {
                label: 'Anagrafiche',
                icon: 'pi pi-home',
                visible: this.role === 'amministratore' || this.role === 'operatore' ,
                items: [
                    {
                        label: 'Pazienti',
                        icon: 'pi pi-fw pi-user',
                        routerLink: ['/pazienti'],
                    },
                    {
                        label: 'Medici',
                        icon: 'pi pi-fw pi-user',
                        routerLink: ['/medici'],
                    },
                    {
                        label: 'Aree',
                        icon: 'pi pi-fw pi-heart',
                        routerLink: ['/specializzazioni'],
                    },
                    {
                        label: 'Testi consenso',
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['/condizioni-consenso'],
                        visible: this.role === 'amministratore' ,
                    },
                    {
                        label: 'Operatori',
                        icon: 'pi pi-fw pi-user',
                        routerLink: ['/operatori'],
                        visible: this.role === 'amministratore' ,
                    },
                ],
            },

            {
                label: 'Consulti',
                icon: 'pi pi-home',
                visible: this.role === 'amministratore' || this.role === 'operatore',
                items: [
                    {
                        label: 'Elenco consulti',
                        routerLink: ['/consulti'],
                        customIcon: 'assets/icons/consulti.svg',
                    },
                    {
                        label: 'Crea visita',
                        customIcon: 'assets/icons/consulti.svg',
                        routerLink: ['/creavisita'],
                    }, {
                        label: 'Feedback',
                        icon: 'pi pi-star',
                        routerLink: ['/feedback'],
                    },
                ],
            },

            {
                label: 'Fatture',
                icon: 'pi pi-home',
                visible: this.role === 'amministratore' || this.role === 'operatore',
                items: [
                    {
                        label: 'Fatture',
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['/fatture'],
                    },
                    {
                        label: 'Marche da bollo',
                        icon: 'pi pi-fw pi-bookmark',
                        routerLink: ['/marche-da-bollo'],
                    },
                ],
            },

            {
                label: 'Logs',
                icon: 'pi pi-list',
                visible: this.role === 'amministratore' || this.role === 'operatore',
                items: [
                    {
                        label: 'Logs',
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['/logs'],
                    },
                ],
            },

            {
                label: 'Scontistiche',
                icon: 'pi pi-shopping-bag',
                visible: this.role === 'amministratore' || this.role === 'operatore',
                items: [
                    {
                        label: 'Convenzioni',
                        icon: 'pi pi-fw pi-gift',
                        routerLink: ['/convenzioni'],
                        visible: this.role === 'amministratore',
                    },
                    {
                        label: 'Voucher',
                        icon: 'pi pi-fw pi-gift',
                        routerLink: ['/voucher'],
                    },
                ],
            },

            {
                label: 'Area medico',
                icon: 'pi pi-home',
                visible: this.role === 'medico',
                items: [


                    {
                        label: 'Agenda',
                        icon: 'pi pi-fw pi-calendar',
                        routerLink: ['/agenda/' + this.medicoId ],
                    },
                    {
                        label: 'Consulti',
                        customIcon: 'assets/icons/consulti.svg',
                        routerLink: ['/consultimedico'],
                    },
                    {
                        label: 'Fatture',
                        icon: 'pi pi-fw pi-receipt',
                        routerLink: ['/fatture'],
                    },

                ],
            },

            {
                label: translatedLabels['Area pazienti'],
                icon: 'pi pi-home',
                visible: this.role === 'paziente',
                items: [
                    {
                        label: translatedLabels['Consulti acquistati'],
                        customIcon: 'assets/icons/consulti.svg',
                        routerLink: ['/consultipaziente'],
                    },
                    {
                        label: translatedLabels['Cartella anamnestica'],
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['/anamnesipaziente'],
                    },/*
                    {
                        label: translatedLabels['Convenzioni'],
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/pages/clinicheconvenzionate'],
                    },*/
                    {
                        label: translatedLabels['Documenti fiscali'],
                        icon: 'pi pi-fw pi-receipt',
                        routerLink: ['/fatture'],
                    },

                ],
            },

            {
                label: translatedLabels['Comandi rapidi'],
                icon: 'pi pi-cog',
                visible: this.role === 'paziente',
                items: [
                    {
                        label: translatedLabels['Richiedi consulto'],
                        icon: 'pi pi-fw pi-file',
                        url: ['https://www.doctorium.it/visite-online/'],
                        target: "_blank",
                    },
                    /*
                    {
                        label: translatedLabels['Cambia password'],
                        icon: 'pi pi-fw pi-key',
                        routerLink: ['/cambiapassword'],
                    },
                    */

                ],
            },

            {
                label: 'Tabelle d\'appoggio',
                icon: 'pi pi-home',
                visible: this.role === 'amministratore',
                items: [
                    {
                        label: 'Provenienze',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/provenienze'],
                    },
                ],
            },
/*
            {
                label: 'Consensi',
                icon: 'pi pi-file-check',
                items: [
                    {
                        label: 'Consenso televisita',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['/pages/consensotelevisita'],
                    },
                    {
                        label: 'Consenso telemedicina',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['/pages/consensotelemedicina'],
                    },
                    {
                        label: 'Consenso commerciale',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['/pages/consensocommerciale'],
                    },
                    {
                        label: 'Consenso profilazione',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['/pages/consensoprofilazione'],
                    },
                    {
                        label: 'Informativa telemedicina',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['/pages/informativatelemedicina'],
                    },
                    {
                        label: 'Condizioni di servizio',
                        icon: 'pi pi-fw pi-external-link',
                        url: ['https://www.doctorium.it/condizioni-di-servizio-doctorium/'],
                        target: "_blank",
                    },
                    {
                        label: 'Informativa privacy',
                        icon: 'pi pi-fw pi-external-link',
                        url: ['https://www.doctorium.it/privacy-policy/'],
                        target: "_blank",
                    },
                    {
                        label: 'Informativa cookie',
                        icon: 'pi pi-fw pi-external-link',
                        url: ['https://www.iubenda.com/privacy-policy/99053497/cookie-policy'],
                        target: '_blank',
                    },
                ],
            },

 */
/*
            {
                label: 'Favorites',
                icon: 'pi pi-home',
                items: [
                    {
                        label: 'Dashboard',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/'],
                    },
                ],
            },
            {
                label: 'Apps',
                icon: 'pi pi-th-large',
                items: [
                    {
                        label: 'Blog',
                        icon: 'pi pi-fw pi-comment',
                        items: [
                            {
                                label: 'List',
                                icon: 'pi pi-fw pi-image',
                                routerLink: ['/apps/blog/list'],
                            },
                            {
                                label: 'Detail',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/detail'],
                            },
                            {
                                label: 'Edit',
                                icon: 'pi pi-fw pi-pencil',
                                routerLink: ['/apps/blog/edit'],
                            },
                        ],
                    },
                    {
                        label: 'Calendar',
                        icon: 'pi pi-fw pi-calendar',
                        routerLink: ['/apps/calendar'],
                    },
                    {
                        label: 'Chat',
                        icon: 'pi pi-fw pi-comments',
                        routerLink: ['/apps/chat'],
                    },
                    {
                        label: 'Files',
                        icon: 'pi pi-fw pi-folder',
                        routerLink: ['/apps/files'],
                    },
                    {
                        label: 'Kanban',
                        icon: 'pi pi-fw pi-sliders-v',
                        routerLink: ['/apps/kanban'],
                    },
                    {
                        label: 'Mail',
                        icon: 'pi pi-fw pi-envelope',
                        items: [
                            {
                                label: 'Inbox',
                                icon: 'pi pi-fw pi-inbox',
                                routerLink: ['/apps/mail/inbox'],
                            },
                            {
                                label: 'Compose',
                                icon: 'pi pi-fw pi-pencil',
                                routerLink: ['/apps/mail/compose'],
                            },
                            {
                                label: 'Detail',
                                icon: 'pi pi-fw pi-comment',
                                routerLink: ['/apps/mail/detail/1000'],
                            },
                        ],
                    },
                    {
                        label: 'Task List',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['/apps/tasklist'],
                    },
                ],
            },
            {
                label: 'UI Kit',
                icon: 'pi pi-fw pi-star-fill',
                items: [
                    {
                        label: 'Form Layout',
                        icon: 'pi pi-fw pi-id-card',
                        routerLink: ['/uikit/formlayout'],
                    },
                    {
                        label: 'Input',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['/uikit/input'],
                    },
                    {
                        label: 'Float Label',
                        icon: 'pi pi-fw pi-bookmark',
                        routerLink: ['/uikit/floatlabel'],
                    },
                    {
                        label: 'Invalid State',
                        icon: 'pi pi-fw pi-exclamation-circle',
                        routerLink: ['/uikit/invalidstate'],
                    },
                    {
                        label: 'Button',
                        icon: 'pi pi-fw pi-box',
                        routerLink: ['/uikit/button'],
                    },
                    {
                        label: 'Table',
                        icon: 'pi pi-fw pi-table',
                        routerLink: ['/uikit/table'],
                    },
                    {
                        label: 'List',
                        icon: 'pi pi-fw pi-list',
                        routerLink: ['/uikit/list'],
                    },
                    {
                        label: 'Tree',
                        icon: 'pi pi-fw pi-share-alt',
                        routerLink: ['/uikit/tree'],
                    },
                    {
                        label: 'Panel',
                        icon: 'pi pi-fw pi-tablet',
                        routerLink: ['/uikit/panel'],
                    },
                    {
                        label: 'Overlay',
                        icon: 'pi pi-fw pi-clone',
                        routerLink: ['/uikit/overlay'],
                    },
                    {
                        label: 'Media',
                        icon: 'pi pi-fw pi-image',
                        routerLink: ['/uikit/media'],
                    },
                    {
                        label: 'Menu',
                        icon: 'pi pi-fw pi-bars',
                        routerLink: ['/uikit/menu'],
                        routerLinkActiveOptions: {
                            paths: 'subset',
                            queryParams: 'ignored',
                            matrixParams: 'ignored',
                            fragment: 'ignored',
                        },
                    },
                    {
                        label: 'Message',
                        icon: 'pi pi-fw pi-comment',
                        routerLink: ['/uikit/message'],
                    },
                    {
                        label: 'File',
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['/uikit/file'],
                    },
                    {
                        label: 'Chart',
                        icon: 'pi pi-fw pi-chart-bar',
                        routerLink: ['/uikit/charts'],
                    },
                    {
                        label: 'Misc',
                        icon: 'pi pi-fw pi-circle-off',
                        routerLink: ['/uikit/misc'],
                    },
                ],
            },
            {
                label: 'Prime Blocks',
                icon: 'pi pi-fw pi-prime',
                items: [
                    {
                        label: 'Free Blocks',
                        icon: 'pi pi-fw pi-eye',
                        routerLink: ['/blocks'],
                    },
                    {
                        label: 'All Blocks',
                        icon: 'pi pi-fw pi-globe',
                        url: ['https://www.primefaces.org/primeblocks-ng'],
                        target: '_blank',
                    },
                ],
            },
            {
                label: 'Utilities',
                icon: 'pi pi-fw pi-compass',
                items: [
                    {
                        label: 'PrimeIcons',
                        icon: 'pi pi-fw pi-prime',
                        routerLink: ['utilities/icons'],
                    },
                    {
                        label: 'Colors',
                        icon: 'pi pi-fw pi-palette',
                        routerLink: ['utilities/colors'],
                    },
                    {
                        label: 'PrimeFlex',
                        icon: 'pi pi-fw pi-desktop',
                        url: ['https://www.primefaces.org/primeflex/'],
                        target: '_blank',
                    },

                ],
            },
            {
                label: 'Pages',
                icon: 'pi pi-fw pi-briefcase',
                items: [
                    {
                        label: 'Landing',
                        icon: 'pi pi-fw pi-globe',
                        routerLink: ['/landing'],
                    },
                    {
                        label: 'Auth',
                        icon: 'pi pi-fw pi-user',
                        items: [
                            {
                                label: 'Login',
                                icon: 'pi pi-fw pi-sign-in',
                                routerLink: ['/auth/login'],
                            },
                            {
                                label: 'Error',
                                icon: 'pi pi-fw pi-times-circle',
                                routerLink: ['/auth/error'],
                            },
                            {
                                label: 'Access Denied',
                                icon: 'pi pi-fw pi-lock',
                                routerLink: ['/auth/access'],
                            },
                        ],
                    },
                    {
                        label: 'Crud',
                        icon: 'pi pi-fw pi-pencil',
                        routerLink: ['/pages/crud'],
                    },
                    {
                        label: 'Timeline',
                        icon: 'pi pi-fw pi-calendar',
                        routerLink: ['/pages/timeline'],
                    },
                    {
                        label: 'Invoice',
                        icon: 'pi pi-fw pi-dollar',
                        routerLink: ['/pages/invoice'],
                    },
                    {
                        label: 'Help',
                        icon: 'pi pi-fw pi-question-circle',
                        routerLink: ['/pages/help'],
                    },
                    {
                        label: 'Not Found',
                        icon: 'pi pi-fw pi-exclamation-circle',
                        routerLink: ['/notfound'],
                    },
                    {
                        label: 'Empty',
                        icon: 'pi pi-fw pi-circle-off',
                        routerLink: ['/pages/empty'],
                    },
                    {
                        label: 'FAQ',
                        icon: 'pi pi-fw pi-question',
                        routerLink: ['/pages/faq']
                    },
                    {
                        label: 'Contact Us',
                        icon: 'pi pi-fw pi-phone',
                        routerLink: ['/pages/contact']
                    }
                ],
            },
            {
                label: 'E-Commerce',
                icon: 'pi pi-fw pi-wallet',
                items: [
                    {
                        label: 'Product Overview',
                        icon: 'pi pi-fw pi-image',
                        routerLink: ['ecommerce/product-overview'],
                    },
                    {
                        label: 'Product List',
                        icon: 'pi pi-fw pi-list',
                        routerLink: ['ecommerce/product-list'],
                    },
                    {
                        label: 'New Product',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['ecommerce/new-product'],
                    },
                    {
                        label: 'Shopping Cart',
                        icon: 'pi pi-fw pi-shopping-cart',
                        routerLink: ['ecommerce/shopping-cart'],
                    },
                    {
                        label: 'Checkout Form',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['ecommerce/checkout-form'],
                    },
                    {
                        label: 'Order History',
                        icon: 'pi pi-fw pi-history',
                        routerLink: ['ecommerce/order-history'],
                    },
                    {
                        label: 'Order Summary',
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['ecommerce/order-summary'],
                    },
                ],
            },
            {
                label: 'User Management',
                icon: 'pi pi-fw pi-user',
                items: [
                    {
                        label: 'List',
                        icon: 'pi pi-fw pi-list',
                        routerLink: ['profile/list'],
                    },
                    {
                        label: 'Create',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['profile/create'],
                    },
                ],
            },
            {
                label: 'Hierarchy',
                icon: 'pi pi-fw pi-align-left',
                items: [
                    {
                        label: 'Submenu 1',
                        icon: 'pi pi-fw pi-align-left',
                        items: [
                            {
                                label: 'Submenu 1.1',
                                icon: 'pi pi-fw pi-align-left',
                                items: [
                                    {
                                        label: 'Submenu 1.1.1',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                    {
                                        label: 'Submenu 1.1.2',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                    {
                                        label: 'Submenu 1.1.3',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                ],
                            },
                            {
                                label: 'Submenu 1.2',
                                icon: 'pi pi-fw pi-align-left',
                                items: [
                                    {
                                        label: 'Submenu 1.2.1',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        label: 'Submenu 2',
                        icon: 'pi pi-fw pi-align-left',
                        items: [
                            {
                                label: 'Submenu 2.1',
                                icon: 'pi pi-fw pi-align-left',
                                items: [
                                    {
                                        label: 'Submenu 2.1.1',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                    {
                                        label: 'Submenu 2.1.2',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                ],
                            },
                            {
                                label: 'Submenu 2.2',
                                icon: 'pi pi-fw pi-align-left',
                                items: [
                                    {
                                        label: 'Submenu 2.2.1',
                                        icon: 'pi pi-fw pi-align-left',
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                label: 'Start',
                icon: 'pi pi-fw pi-download',
                items: [
                    {
                        label: 'Buy Now',
                        icon: 'pi pi-fw pi-shopping-cart',
                        url: ['https://www.primefaces.org/store'],
                    },
                    {
                        label: 'Documentation',
                        icon: 'pi pi-fw pi-info-circle',
                        routerLink: ['/documentation'],
                    },
                ],
            },

 */
        ];

        this.model = this.model.filter(menu => {
            menu.items = menu.items.filter((item: any) => item.visible !== false);
            return menu.items.length > 0; // Rimuovi il menu se non ci sono voci visibili
        });
    }

    ngOnDestroy(): void {
        this.langSubscription.unsubscribe();
    }
}
